// TicTacToeGame.js
import React, { useState } from "react";

const TicTacToeGame = () => {
  const [board, setBoard] = useState(Array(9).fill(null));
  const [isXNext, setIsXNext] = useState(true);

  const handleClick = (index) => {
    if (board[index] || calculateWinner(board)) return;
    const newBoard = [...board];
    newBoard[index] = isXNext ? "X" : "O";
    setBoard(newBoard);
    setIsXNext(!isXNext);
  };

  const calculateWinner = (b) => {
    const lines = [
      [0,1,2],[3,4,5],[6,7,8],
      [0,3,6],[1,4,7],[2,5,8],
      [0,4,8],[2,4,6]
    ];
    for (let line of lines) {
      const [a,bIndex,c] = line;
      if (b[a] && b[a] === b[bIndex] && b[a] === b[c]) return b[a];
    }
    return null;
  };

  const winner = calculateWinner(board);

  const resetGame = () => {
    setBoard(Array(9).fill(null));
    setIsXNext(true);
  };

  return (
    <div className="text-center">
      <div className="grid grid-cols-3 gap-2 w-36 md:w-48 mx-auto my-4">
        {board.map((cell, i) => (
          <button
            key={i}
            className="border border-gray-400 w-12 h-12 md:w-16 md:h-16 text-2xl font-bold hover:bg-gray-100"
            onClick={() => handleClick(i)}
          >
            {cell}
          </button>
        ))}
      </div>

      {winner ? (
        <p className="text-green-600 font-bold text-lg">{winner} wins!</p>
      ) : (
        <p className="text-gray-700 font-semibold">Next player: {isXNext ? "X" : "O"}</p>
      )}

      <button
        onClick={resetGame}
        className="mt-4 bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-500 transition"
      >
        Reset Game
      </button>
    </div>
  );
};

export default TicTacToeGame;
